import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var BraceLeft = props => {
  var {
    BraceLeft: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BraceLeft');
  return null;
};
BraceLeft.displayName = 'JVR.BraceLeft';